var map = {
	"./ClusterIP.svg": 1176,
	"./ExternalName.svg": 1177,
	"./Headless.svg": 1178,
	"./LoadBalancer.svg": 1179,
	"./NodePort.svg": 1180,
	"./Opaque.svg": 2153,
	"./account.svg": 1491,
	"./api.svg": 1294,
	"./button/cluster.svg": 1197,
	"./button/flat.svg": 1195,
	"./button/folder.svg": 1196,
	"./cluster.svg": 1295,
	"./copy.svg": 849,
	"./copyKubeConfig.svg": 1296,
	"./custom.svg": 1297,
	"./deploy.svg": 1298,
	"./deployments/info.svg": 1299,
	"./deployments/success.svg": 1300,
	"./deployments/warning.svg": 1301,
	"./downloadKubeConfig.svg": 1302,
	"./error.svg": 868,
	"./explorer/deploy.svg": 1303,
	"./explorer/node.svg": 1304,
	"./explorer/resource.svg": 1305,
	"./importYaml.svg": 1306,
	"./info.svg": 1307,
	"./kubeShell.svg": 1308,
	"./kubernetes.io/basic-auth.svg": 2154,
	"./kubernetes.io/dockerconfigjson.svg": 2155,
	"./kubernetes.io/ssh-auth.svg": 2156,
	"./kubernetes.io/tls.svg": 2157,
	"./monitoring.svg": 1309,
	"./node.svg": 1310,
	"./password.svg": 1492,
	"./resource.svg": 1311,
	"./serviceDiscovery.svg": 1312,
	"./storage.svg": 1313,
	"./success.svg": 1314,
	"./unknown.svg": 869,
	"./user.svg": 1315,
	"./warning.svg": 1316,
	"./workload.svg": 1317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2152;